import {
	Box,
	Heading,
	ListItem,
	Progress,
	Stack,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import Logo from "components/elements/Logo";
import { useLocation } from "react-router-dom";

/**
 * Sidebar for account onboarding
 */
interface OnboardingSidebarProps {
	steps: {
		label: string;
		path: string;
		key: string;
	}[];
}

export default function OnboardingSidebar({ steps }: OnboardingSidebarProps) {
	const { pathname } = useLocation();
	const activeStep = steps.findIndex((step) => step.path === pathname);
	const progress = Math.round(((activeStep + 1) / (steps.length + 1)) * 100);

	return (
		<Stack
			bg="#FDFDFD"
			borderRightRadius="50px"
			boxShadow="0px 0px 15px 0px rgba(198, 198, 198, 0.25)"
			borderWidth="2px"
			borderColor="gray.50"
			w="270px"
			minH="100%"
			pt="38px"
			pl="32px"
		>
			<Logo />
			<Box pr="16px">
				<Heading fontWeight="600" fontSize="20px" lineHeight="28px">
					Account Setup
				</Heading>

				<Progress value={progress} borderRadius="12px" mt="8px" mb="8px" />
				<Text fontWeight="600" fontSize="14px" lineHeight="21px">
					{progress}% complete
				</Text>
				<UnorderedList listStyleType="none" m="0px" mt="28px">
					{steps.map((step, index) => (
						<ListItem key={step.key} display="flex" alignItems="center" mt="20px">
							<Box
								borderWidth="2px"
								borderColor="primary"
								h="20px"
								w="20px"
								mr="8px"
								borderRadius="50%"
								p="4px"
							>
								{activeStep === index && (
									<Box bg="primary" h="8px" w="8px" borderRadius="50%"></Box>
								)}
							</Box>
							<Text fontWeight="500" fontSize="15px">
								{step.label}
							</Text>
						</ListItem>
					))}
				</UnorderedList>
			</Box>
		</Stack>
	);
}
